/** Filename helpers for bid downloads (Content-Disposition + fallback names). */

export function filenameFromContentDisposition(header: string | null): string | null {
  if (!header) {
    return null;
  }

  const utf8Match = /filename\*=(?:UTF-8'')?([^;]+)/i.exec(header);
  if (utf8Match?.[1]) {
    const raw = utf8Match[1].trim().replace(/^["']|["']$/g, '');
    try {
      return decodeURIComponent(raw);
    } catch {
      return raw;
    }
  }

  const basicMatch = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/i.exec(header);
  if (basicMatch?.[1]) {
    return basicMatch[1].replace(/['"]/g, '').trim() || null;
  }

  return null;
}

function sanitizeZipSegment(name: string): string {
  const cleaned = name
    .replace(/[<>:"/\\|?*\u0000-\u001f]/g, '_')
    .replace(/\s+/g, ' ')
    .trim();
  return cleaned || 'archive';
}

function formatPackageDate(date = new Date()): string {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

/** Download name for a bid-templates Excel covering a date range, e.g. `диапазон 2026-08-01-2026-08-27.xlsx`. */
export function buildBidTemplateRangeFilename(
  from: Date,
  to: Date,
  rangeLabel: string
): string {
  return `${sanitizeZipSegment(`${rangeLabel} ${formatPackageDate(from)}-${formatPackageDate(to)}`)}.xlsx`;
}
